import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

function EditItemLocationModal(props) {
  const [b_name, setBname] = useState(props.editData.name);

  const updateItemLocationHandler = (e) => {
    let body = {
      id: props.editData.id,
      name: b_name.trim(),
    };
    PostApiWithAuthorizationAction("common/edit-item-location-render-data", body)
      .then((res) => {
        //toast.success(res.message);
        props.addUpdatedData(res.data);
        props.toggle();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };
  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Update Item Location Details</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-control-label" for="b_name">
            Item Location Name
          </Label>
          <Input
            id="b_name"
            type="text"
            placeholder="Item Location Name"
            value={b_name}
            onChange={(e) => setBname(e.target.value)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
          id="update-btn"
          color="primary"
          onClick={updateItemLocationHandler}
          disabled={b_name.length === 0}
        >
          Update
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditItemLocationModal;
